import numeral from "numeral";
import i18n from "@/i18n/index";

// 将对象的值赋给目标对象
export const valKeys = (obj, target) => {
  for (let key in obj) {
    obj[key] = target[key];
  }
};

// 克隆对象的值到目标对象
export const clonKeys = (target, source) => {
  for (let key in target) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
};

// 清空对象的所有属性值
export const clearKeys = (target) => {
  for (let key in target) {
    if (target[key] instanceof Array) {
      target[key] = [];
    } else {
      target[key] = undefined;
    }
  }
};

// 获取UUID
export const getUuid = () => {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

// 格式化日期
export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};

// 深拷贝
export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return new Date(obj.getTime());
  if (obj instanceof Array) return obj.map(item => deepClone(item));
  if (typeof obj === 'object') {
    const clonedObj = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = deepClone(obj[key]);
      }
    }
    return clonedObj;
  }
};

export function format_with_substring(number) {
  const arr = String(number).split('.');
  const int = arr[0];
  const fraction = arr[1] || '';
  const f = int.length % 3;
  let result = int.substring(0, f);
  for (let i = 0; i < Math.floor(int.length / 3); i++) {
    result += ',' + int.substring(f + i * 3, f + (i + 1) * 3);
  }
  if (f === 0) result = result.substring(1);
  return result + (fraction ? '.' + fraction : '');
}

export const formatPrice = (params) => numeral(params).format("0,0.00");

export const generatePriceRangeText = (priceRangeList) => {
  const result = [];
  const sorted = [...priceRangeList].sort((a, b) => Number(a.startQuantity) - Number(b.startQuantity));
  for (let i = 0; i < sorted.length; i++) {
    const current = sorted[i];
    const next = sorted[i + 1];
    if (next) {
      result.push(`数量:${current.startQuantity}-${Number(next.startQuantity) - 1}  ${i18n.t('cart.wslang189')}:${current.price}`);
    } else {
      result.push(`${i18n.t('cart.oneEight34')}:${current.startQuantity}  ${i18n.t('cart.wslang189')}:${current.price}`);
    }
  }
  return result.join('，');
};

export const formatPricingzh = (arr) => arr.map((item, index) => ({
  price: `${item.price}`,
  startQuantity: index === arr.length - 1
    ? `≥${item.startQuantity}`
    : `${item.startQuantity}-${arr[index + 1].startQuantity - 1}`,
}));

export const get1688Price = (priceRangeList, quantity) => {
  if (!priceRangeList || !priceRangeList.length) return undefined;
  const sorted = [...priceRangeList].sort((a, b) => Number(a.startQuantity) - Number(b.startQuantity));
  let price = sorted[0].price;
  sorted.forEach((range) => {
    if (Number(quantity) >= Number(range.startQuantity)) price = range.price;
  });
  return price;
};
